import React, {Component} from 'react'
import { monthDayYear } from '../helpers/formatters';
import DatePicker from './DatePicker';

class DateRangePicker extends Component {
     state = {
        isOpen: false,
        isPicker: false
      };
    
    onToggle = () => {
      this.setState({ isOpen: !this.state.isOpen });
      if(this.state.isPicker === true){
        this.setState({ isPicker: false });
      }
    };

    toggleDateRangeClasses = () => {
        this.setState({ isPicker: !this.state.isPicker });
    };

    selectRangeHandle = (e) => {
        if(e.target.value === 'custom_range'){
            console.log('[[[SELECT CUSTOM]]]:',e.target.value)
            this.toggleDateRangeClasses();
            return;
        }else
        if(e.target.value !== 'none'){
            console.log('[[[SELECT RANGE]]]:',e.target.value)
            
            this.props.setDateRange && this.props.setDateRange(e.target.value);
            
            this.setState({ isOpen: !this.state.isOpen });
            if(this.state.isPicker === true){
                this.setState({ isPicker: false });
            }
        }else{
            console.log('[[[SELECT NONE]]]:',e.target.value)
            this.setState({ isOpen: !this.state.isOpen });
            if(this.state.isPicker === true){
                this.setState({ isPicker: false });
            }
        }
        
    }

    setDate = (date) => {
        this.setState({ isOpen: !this.state.isOpen });
        this.props.setDate({
            from: date.from,
            to: date.to
          });
          this.setState({ isPicker: !this.state.isPicker });
    }

    renderSelectionValue = () => {
      return (
        <>
            <div className="date-box-text" onClick={this.onToggle}>
                {monthDayYear(this.props.from)} - {monthDayYear(this.props.to)}
                <i className="material-icons">date_range</i>
            </div>
        </>  
      );
    };
  
    render() {
        let dateClasses = this.state.isPicker ? "active" : "";
      return (
        <>
        <div className="form-field">
            <h5 className="label">Date Range</h5>  
            <div className="date-box">
                {this.renderSelectionValue()}
                {this.state.isPicker && (
                <div className={`DatePickerParent ${dateClasses}`}>
                    <DatePicker onDateChange={this.props.setDate} toggle={this.toggleDateRangeClasses}/>
                </div>)
            }
            </div>
        </div>
        {this.state.isOpen && (
            <div className="form-field">
              <select
                onChange={this.selectRangeHandle}
                defaultValue="none"
              >
                <option value="none">None</option>  
                <option value="today">Today</option>
                <option value="yesterday">Yesterday</option>
                <option value="last_7">Last 7 Days</option>
                <option value="last_30">Last 30 Days</option>
                <option value="this_month">This Month</option>
                <option value="last_month">Last Month</option>
                <option value="last_2_months">Last 2 Month</option>
                <option value="last_3_months">Last 3 Month</option>
                <option value="custom_range">Custome Range</option>
              </select>
            </div>
          )}
        </>
      );
    }
  }
 
export default DateRangePicker;
